import { Drawer } from 'antd'

import { drawerAndModalWidth } from '../../../../util/guideline'
import { CreateBespokeRating } from './CreateBespokeRating'

interface CreateBespokeRatingDrawerProps {
  domain: string
  isVisible: boolean
  onClose: () => void
  onSuccess: () => void
}

export const CreateBespokeRatingDrawer = ({
  domain,
  isVisible,
  onClose,
  onSuccess,
}: CreateBespokeRatingDrawerProps) => (
  <Drawer
    title="Create bespoke rating"
    placement="right"
    open={isVisible}
    onClose={onClose}
    width={drawerAndModalWidth}
    destroyOnClose
  >
    <CreateBespokeRating domain={domain} onSuccess={onSuccess} />
  </Drawer>
)
